export const emailValid = (email) => {
  var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const checkValidStoredUUID = (uuid) => {
  if (!uuid) {
    window.location.href = "http://www.nla.com.au/";
    return;
  }
};
